<style scoped lang="scss">
.input-group-text,
.border-left-0 {
  min-height: 34px;
}

#standar-data-statistik-nasional {
  background: #f8f8f8;
}
</style>
<template>
  <div>
    <div id="standar-data-statistik-nasional" class="content content--borderless">
      <div class="content__breadcrumbs">
        <Breadcrumbs :items="breadcrumbs"></Breadcrumbs>
      </div>
      <div class="content__header" style="padding-bottom:40px">
        <div class="content__main-header">
          <div class="content__title">
            <div class="content__title__name">Standar Data Statistik Nasional</div>
            <div class="content__title__description">Berdasarkan Keputusan Kepala Badan Pusat Statistik Nomor 850 Tahun 2023</div>
          </div>
          <div class="ml-auto d-flex" style="display:none !important">
            <b-button type="button" class=" ml-2 button button--primary button--sm" @click="exportToExcel">
              <VueFeather type="upload" size="14" class="button__icon"></VueFeather>
              Export
            </b-button>
          </div>
        </div>
      </div>
      <div class="content__body pb-5" style="margin-top:-40px">
        <div class="table-search">
          <b-input-group>
            <b-input-group-prepend is-text class="bg-none">
              <VueFeather type="search" size="16" stroke-width="3" stroke="#919191"></VueFeather>
            </b-input-group-prepend>
            <Treeselect :clearable="false" placeholder="Pilih tipe SDS" v-model="search.tipe"
              :options="options.sdsType" />
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend is-text class="bg-none">
              <VueFeather type="search" size="16" stroke-width="3" stroke="#919191"></VueFeather>
            </b-input-group-prepend>
            <b-form-input type="search" debounce="500" size="sm" v-model="search.kodeSds" placeholder="Kode SDS"
              class="border-left-0">
            </b-form-input>
          </b-input-group>
          <b-input-group v-if="search.tipe != 2">
            <b-input-group-prepend is-text class="bg-none">
              <VueFeather type="type" size="16" stroke-width="3" stroke="#919191"></VueFeather>
            </b-input-group-prepend>
            <b-form-input type="search" debounce="500" size="sm" v-model="search.namaData" placeholder="Nama Data"
              class="border-left-0">
            </b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend is-text class="bg-none">
              <VueFeather type="type" size="16" stroke-width="3" stroke="#919191"></VueFeather>
            </b-input-group-prepend>
            <b-form-input type="search" debounce="500" size="sm" v-model="search.konsep" placeholder="Konsep"
              class="border-left-0">
            </b-form-input>
          </b-input-group>
          <b-form-group label="Jumlah baris:" label-size="sm" label-cols-lg="auto" label-align-sm="right"
            label-class="text-reguler text-13" class="mb-0 ml-5">
            <b-form-select v-model="pagination.pageSize" :options="options.page" size="sm"
              @change="getSdsnList"></b-form-select>
          </b-form-group>
        </div>
        <div class="table-wrapper mt-2">
          <b-table v-if='search.tipe != 2' class="table--light" show-empty :items="sdsn" :fields="fields">
            <template #head(selected)>
              <b-form-checkbox v-model="selectedAll"
                @change="(checked) => { selectAllItemSdsn(checked) }"></b-form-checkbox>
            </template>
            <template #cell(selected)="data">
              <b-form-checkbox v-model="data.item.selected" @change="itemSdsnSelected"></b-form-checkbox>
            </template>
            <template #cell(no)="data">
              {{ startRowNumber + data.index }}
            </template>
            <template #head(kodeSds)="data">
              <div class="d-flex align-items-center">
                <div>{{ data.label }}</div>
                <div class="ml-1">
                  <b-button type="button" class="button button--action" v-show="sortBy[0].direction == null"
                    @click="sortSdsn(sortBy[0])">
                    <b-icon icon="chevron-expand"></b-icon>
                  </b-button>
                  <b-button type="button" class="button button--action" v-show="sortBy[0].direction == 'asc'"
                    @click="sortSdsn(sortBy[0])">
                    <b-icon icon="sort-alpha-down"></b-icon>
                  </b-button>
                  <b-button type="button" class="button button--action" v-show="sortBy[0].direction == 'desc'"
                    @click="sortSdsn(sortBy[0])">
                    <b-icon icon="sort-alpha-up"></b-icon>
                  </b-button>
                </div>
              </div>
            </template>
            <template #head(namaData)="data">
              <div class="d-flex align-items-center">
                <div>{{ data.label }}</div>
                <div class="ml-1">
                  <b-button type="button" class="button button--action" v-show="sortBy[1].direction == null"
                    @click="sortSdsn(sortBy[1])">
                    <b-icon icon="chevron-expand"></b-icon>
                  </b-button>
                  <b-button type="button" class="button button--action" v-show="sortBy[1].direction == 'asc'"
                    @click="sortSdsn(sortBy[1])">
                    <b-icon icon="sort-alpha-down"></b-icon>
                  </b-button>
                  <b-button type="button" class="button button--action" v-show="sortBy[1].direction == 'desc'"
                    @click="sortSdsn(sortBy[1])">
                    <b-icon icon="sort-alpha-up"></b-icon>
                  </b-button>
                </div>
              </div>
            </template>
            <template #cell(konsep)="data">
              <ul>
                <li v-for="item in data.item.konsep.split(';').slice(0, -1)" v-bind:key="item">
                  {{ item }}</li>
              </ul>
            </template>
            <template #cell(klasifikasiPenyajian)="data">
              <ul>
                <li v-for="item in data.item.klasifikasiPenyajian.split(';').slice(0, -1)" v-bind:key="item">
                  {{ item }}</li>
              </ul>
            </template>
            <template #cell(klasifikasiIsian)="data">
                <span v-for="item in data.item.klasifikasiIsian.split(';').slice(0, -1)" v-bind:key="item">
                  {{ item }}<br /></span>
            </template>
            <template #head(konsep)="data">
              <div class="d-flex align-items-center">
                <div>{{ data.label }}</div>
                <div class="ml-1">
                  <b-button type="button" class="button button--action" v-show="sortBy[2].direction == null"
                    @click="sortSdsn(sortBy[2])">
                    <b-icon icon="chevron-expand"></b-icon>
                  </b-button>
                  <b-button type="button" class="button button--action" v-show="sortBy[2].direction == 'asc'"
                    @click="sortSdsn(sortBy[2])">
                    <b-icon icon="sort-alpha-down"></b-icon>
                  </b-button>
                  <b-button type="button" class="button button--action" v-show="sortBy[2].direction == 'desc'"
                    @click="sortSdsn(sortBy[2])">
                    <b-icon icon="sort-alpha-up"></b-icon>
                  </b-button>
                </div>
              </div>
            </template>
            <template #cell(action)="data">
              <b-button type="button" class="button button--action button--action--edit"
                @click="sdsnDetail = data.item; $bvModal.show('modal-detail-sdsn')">
                <VueFeather type="eye" size="14"></VueFeather>
              </b-button>
            </template>
            <template #empty>
              <div class="text-danger d-flex justify-content-center align-items-center pb-2">
                <div v-if="isLoading" class="d-flex align-items-center">
                  <VueFeather type="loader" animation="spin" size="18" style="display :block"></VueFeather> &nbsp; Memuat
                  data
                </div>
                <div v-else class="d-flex align-items-center">
                  <VueFeather type="alert-circle" size="18" style="display :block"></VueFeather> &nbsp; Tidak ada data
                  yang tersedia
                </div>
              </div>
            </template>

          </b-table>
          <b-table v-else class="table--light" show-empty :items="sdsn" :fields="fieldConcepts">
            <template #head(selected)>
              <b-form-checkbox v-model="selectedAll"
                @change="(checked) => { selectAllItemSdsn(checked) }"></b-form-checkbox>
            </template>
            <template #cell(selected)="data">
              <b-form-checkbox v-model="data.item.selected" @change="itemSdsnSelected"></b-form-checkbox>
            </template>
            <template #cell(no)="data">
              {{ startRowNumber + data.index }}
            </template>
            <template #head(kodeSds)="data">
              <div class="d-flex align-items-center">
                <div>{{ data.label }}</div>
                <div class="ml-1">
                  <b-button type="button" class="button button--action" v-show="sortBy[0].direction == null"
                    @click="sortSdsn(sortBy[0])">
                    <b-icon icon="chevron-expand"></b-icon>
                  </b-button>
                  <b-button type="button" class="button button--action" v-show="sortBy[0].direction == 'asc'"
                    @click="sortSdsn(sortBy[0])">
                    <b-icon icon="sort-alpha-down"></b-icon>
                  </b-button>
                  <b-button type="button" class="button button--action" v-show="sortBy[0].direction == 'desc'"
                    @click="sortSdsn(sortBy[0])">
                    <b-icon icon="sort-alpha-up"></b-icon>
                  </b-button>
                </div>
              </div>
            </template>
            <template #head(namaData)="data">
              <div class="d-flex align-items-center">
                <div>{{ data.label }}</div>
                <div class="ml-1">
                  <b-button type="button" class="button button--action" v-show="sortBy[1].direction == null"
                    @click="sortSdsn(sortBy[1])">
                    <b-icon icon="chevron-expand"></b-icon>
                  </b-button>
                  <b-button type="button" class="button button--action" v-show="sortBy[1].direction == 'asc'"
                    @click="sortSdsn(sortBy[1])">
                    <b-icon icon="sort-alpha-down"></b-icon>
                  </b-button>
                  <b-button type="button" class="button button--action" v-show="sortBy[1].direction == 'desc'"
                    @click="sortSdsn(sortBy[1])">
                    <b-icon icon="sort-alpha-up"></b-icon>
                  </b-button>
                </div>
              </div>
            </template>
            <template #head(konsep)="data">
              <div class="d-flex align-items-center">
                <div>{{ data.label }}</div>
                <div class="ml-1">
                  <b-button type="button" class="button button--action" v-show="sortBy[2].direction == null"
                    @click="sortSdsn(sortBy[2])">
                    <b-icon icon="chevron-expand"></b-icon>
                  </b-button>
                  <b-button type="button" class="button button--action" v-show="sortBy[2].direction == 'asc'"
                    @click="sortSdsn(sortBy[2])">
                    <b-icon icon="sort-alpha-down"></b-icon>
                  </b-button>
                  <b-button type="button" class="button button--action" v-show="sortBy[2].direction == 'desc'"
                    @click="sortSdsn(sortBy[2])">
                    <b-icon icon="sort-alpha-up"></b-icon>
                  </b-button>
                </div>
              </div>
            </template>
            <template #cell(action)="data">
              <b-button type="button" class="button button--action button--action--edit"
                @click="sdsnDetail = data.item; $bvModal.show('modal-detail-sdsn')">
                <VueFeather type="eye" size="14"></VueFeather>
              </b-button>
            </template>
            <template #empty>
              <div class="text-danger d-flex justify-content-center align-items-center pb-2">
                <div v-if="isLoading" class="d-flex align-items-center">
                  <VueFeather type="loader" animation="spin" size="18" style="display :block"></VueFeather> &nbsp; Memuat
                  data
                </div>
                <div v-else class="d-flex align-items-center">
                  <VueFeather type="alert-circle" size="18" style="display :block"></VueFeather> &nbsp; Tidak ada data
                  yang tersedia
                </div>
              </div>
            </template>

          </b-table>
          <b-pagination class="mt-3" v-model="pagination.currentPage" :total-rows="pagination.totalElements"
            :per-page="pagination.pageSize" align="center" @input="handlePageChange"
            v-if="pagination.totalElements > 0 && isLoading == false"></b-pagination>
        </div>
      </div>
      <b-modal hide-header hide-footer id="modal-error" content-class="modal-notif modal-warning"
        dialog-class="d-flex justify-content-center">
        <div class="modal__body flex">
          <div>
            <div class="modal__icon">
              <VueFeather type="alert-triangle"></VueFeather>
            </div>
          </div>
          <div class="modal__text">
            <div class="modal__text--main">Silakan pilih item yang akan di export</div>
            <div>Untuk memuat lebih banyak item yang akan diexport Anda bisa mengganti jumlah baris dengan angka yang
              lebih besar</div>
          </div>
          <div class="modal__action">
            <button class="button" variant="warning" v-on:click="() => { $bvModal.hide('modal-error'); }">OK</button>
          </div>
        </div>
      </b-modal>

      <b-modal hide-header hide-footer size="lg" id="modal-detail-sdsn" modal-class="modal-secondary primary">
        <div class="modal__header secondary">
          <div class="modal__header__icon">
            <VueFeather type="info" size="18" stroke-width="2"></VueFeather>
          </div>
          <div class="">
            <div class="modal__title">
              Detil SDSN
            </div>
            <div class="modal__description">
              Informasi lengkap terkait Standar Data Statistik Nasional
            </div>
          </div>
          <div class="modal__header__close">
            <b-button class="button button--action button--action--view" @click="$bvModal.hide('modal-detail-sdsn')">
              <VueFeather type="x" size="14" stroke-width="2"></VueFeather>
            </b-button>
          </div>
        </div>
        <div class="modal__body mt-2" v-if="sdsnDetail">
          <b-table-simple class="table--stacked table--stacked--primary">
            <b-tbody>
              <b-tr>
                <b-th>Kode SDSN</b-th>
                <b-td>{{ sdsnDetail.idSds }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>No. Indikator</b-th>
                <b-td>{{ sdsnDetail.noIndikator }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Konsep</b-th>
                <b-td>{{ sdsnDetail.konsep }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Definisi</b-th>
                <b-td>{{ sdsnDetail.definisi }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Ukuran</b-th>
                <b-td>{{ sdsnDetail.ukuran }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Satuan</b-th>
                <b-td>{{ sdsnDetail.satuan }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Klasifikasi</b-th>
                <b-td>{{ sdsnDetail.klasifikasi }}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Sumber Referensi</b-th>
                <b-td>{{ sdsnDetail.sumberContent }}</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
        <div class="modal__footer border-top-0 pt-0">
          <div class="modal__footer__action">
            <b-button class="button button--primary" @click="$bvModal.hide('modal-detail-sdsn');">
              Tutup
            </b-button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import "@/assets/scss/main.scss";
import Breadcrumbs from "@/components/Breadcrumbs";
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import moment from 'moment';
import VueFeather from 'vue-feather';
import XLSX from 'xlsx';

import sdsService from "../../services/SdsService";
export default {
  components: {
    Treeselect,
    VueFeather,
    Breadcrumbs
  },
  data () {
    return {
      breadcrumbs: [
        {
          text: "Home",
          href: "/old-sds",
        },
        {
          text: "Daftar standar data statistik nasional",
          href: '',
          active: true,
        },
      ],
      sdsType: null,
      isLoading: true,
      roles: [],
      selectedAjudicationTypeIndex: 0,
      ajudicationTypes: [
        {
          icon: 'grid',
          title: "Mikrodata",
          description: "Mikrodata adalah data tentang kharakteristik dari unit suatu populasi,seperti individu, rumah tangga, atau perusahaan, yang dikumpulkan melalui sensus, survei, atau eksperimen.",
          link: "/ajudication/microdata/create",
          tag: "",
          color: "primary",
          fill: "#00CBA9",
        },
        {
          icon: 'package',
          title: "Makrodata",
          description: "Mikrodata adalah data tentang kharakteristik dari unit suatu populasi,seperti individu, rumah tangga, atau perusahaan, yang dikumpulkan melalui sensus, survei, atau eksperimen.",
          link: "/ajudication/macrodata/create",
          tag: "",
          color: "secondary",
          fill: "#80D8FF",
        },
      ],
      selectedAll: false,
      sdsnPeriod: null,
      sdsn: [],
      selectedSdsn: [],
      sdsnDetail: null,
      fieldConcepts: [
        {
          key: 'selected',
          label: '',
          class: 'text-center'
        },
        {
          key: 'no',
          class: 'text-center'
        },
        {
          key: 'kodeSds',
          label: 'Kode SDS',
          class: 'text-left text-nowrap',
        },
        {
          key: 'konsep',
          class: 'text-left'
        },
        {
          key: 'definisi',
          class: 'text-left'
        }
      ],
      fields: [
        {
          key: 'selected',
          label: '',
          class: 'text-center'
        },
        {
          key: 'no',
          class: 'text-center'
        },
        {
          key: 'kodeSds',
          label: 'Kode SDS',
          class: 'text-left text-nowrap'
        },
        {
          key: 'namaData',
          label: 'Nama Data',
          class: 'text-left'
        },
        {
          key: 'konsep',
          class: 'text-left'
        },
        {
          key: 'definisi',
          class: 'text-left'
        },
        {
          key: 'klasifikasiPenyajian',
          class: 'text-left'
        },
        {
          key: 'klasifikasiIsian',
          class: 'text-left'
        },
        {
          key: 'ukuran',
          class: 'text-left'
        },
        {
          key: 'satuan',
          class: 'text-left'
        },
      ],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        first: null,
        last: null,
        totalPages: null,
        totalElements: null,
        initialTotalElements: null,
        initialLoad: false,
      },
      search: {
        kodeSds: null,
        namaData: null,
        konsep: null,
        definisi: null,
        klasifikasi: null,
        ukuran: null,
        satuan: null,
        tipe: 1
      },
      sortBy: [
        {
          property: "idSds",
          direction: null
        },
        {
          property: "noIndikator",
          direction: null
        },
        {
          property: "konsep",
          direction: null
        }
      ],
      response: null,
      modal: {
        error: {
          title: null,
          description: null,
        }
      },
      options: {
        sdsType: [
          { id: '1', label: 'Standar Data Statistik' },
          { id: '2', label: 'Konsep' }
        ],
        page: [
          { value: 10, text: '10' },
          { value: 20, text: '20' },
          { value: 50, text: '50' },
          { value: 100, text: '100' },
        ],
      }
    }
  },
  computed: {
    elementInfo () {
      let start = this.pagination.totalElements == 0 ? '0' : (this.pagination.currentPage - 1) * this.pagination.pageSize + 1;
      let end = this.pagination.totalPages > 1 ? (this.pagination.currentPage) * this.pagination.pageSize : this.pagination.totalElements;
      return start + ' - ' + end + ' approval';
    },
    startRowNumber () {
      return this.pagination.totalElements == 0 ? '0' : (this.pagination.currentPage - 1) * this.pagination.pageSize + 1;
    },

  },
  watch: {
    search: {
      handler () {
        this.resetSortSdsn();
        this.getSdsnList();
      },
      deep: true
    },
  },
  async mounted () {
    this.getSettings();
    await this.getSdsnList();
  },
  methods: {
    setSubmissionPeriod () {
      let currentYear = new Date().getFullYear();
      this.submissionPeriod = currentYear;
      this.options.submissionPeriod = this.range(2021, currentYear)

    },
    async getSettings () {
      await sdsService.getSettings().then(
        (result) => {
          this.sdsnPeriod = result.data.body.filter(x => x.property == 'sdsn_period')[0].value;
        },
        (error) => {
          console.log(error);
        }
      )
    },
    async getSdsnList () {
      this.isLoading = true;
      let sortBy = this.sortBy.filter(x => x.direction != null);
      await sdsService.getSdsn2022List(
        this.search.kodeSds, this.search.namaData, this.search.konsep, this.search.definisi, this.search.klasifikasiPenyajian, this.search.klasifikasiIsian,
        this.search.ukuran, this.search.satuan, this.search.tipe, this.pagination.currentPage - 1, this.pagination.pageSize, sortBy).then(
          (result) => {
            this.response = result;
            let response = result.data;
            this.sdsn = response.content.map(item => ({ ...item, selected: false }));
            this.pagination.first = response.first;
            this.pagination.last = response.last;
            this.pagination.totalPages = response.tototalPagestal_pages;
            this.pagination.totalElements = response.totalElements
            if (!this.pagination.initialLoad) {
              this.pagination.initialTotalElements = response.totalElements
              this.pagination.initialLoad = true;
            }
            this.selectedAll = false;
          },
          (error) => {
            console.log(error);
          }
        );
      this.isLoading = false;
    },
    selectAllItemSdsn (checked) {
      this.sdsn.forEach(x => {
        x.selected = checked
      })
      this.itemSdsnSelected();
    },
    itemSdsnSelected () {
      this.selectedSdsn = this.sdsn.filter(x => x.selected == true);
    },
    resetSortSdsn () {
      this.sortBy = [
        {
          property: "kodeSds",
          direction: null
        },
        {
          property: "namaData",
          direction: null
        },
        {
          property: "konsep",
          direction: null
        }
      ];
    },
    sortSdsn (sortOrder) {
      if (sortOrder.direction == null) {
        sortOrder.direction = "asc";
      } else if (sortOrder.direction == "asc") {
        sortOrder.direction = "desc";
      } else {
        sortOrder.direction = null;
      }
      this.getSdsnList()
    },
    exportToExcel () {
      if (this.selectedSdsn.length > 0) {
        /* make worksheet from json */
        const worksheetName = 'data';
        const data = this.selectedSdsn.map((item, index) => {
          return {
            'No': index + 1,
            'Kode Sds': item.idSds,
            'No. Indikator': item.noIndikator,
            'Konsep': item.konsep,
            'Definisi': item.definisi,
            'Klasifikasi': item.klasifikasi,
            'Ukuran': item.ukuran,
            'Satuan': item.satuan
          }
        })
        const worksheetData = XLSX.utils.json_to_sheet(data)
        /* create a new blank workbook */
        const workbook = XLSX.utils.book_new()
        /* Add the worksheet to the workbook */
        XLSX.utils.book_append_sheet(workbook, worksheetData, worksheetName)
        /*create file*/
        const createdDate = moment(new Date()).format('DD_MM_YYYY');
        const fileName = 'sdsn_' + createdDate + '.xlsx'
        XLSX.writeFile(workbook, fileName)
      } else {
        this.$bvModal.show('modal-error');
      }

    },
    delay (time) {
      return new Promise(resolve => setTimeout(resolve, time));
    },
    goTo (link) {
      this.$router.push(link);
    },
    edit (type, id) {
      let link = '';
      if (type == 'MICRODATA') {
        link = '../../ajudication/microdata/update/' + id;
      }
      else if (type == 'MACRODATA') {
        link = '../../ajudication/microdata/update/' + id;
      }
      else if (type == 'PUBLICATION') {
        link = '../../ajudication/publication/update/' + id;
      } else {
        link = '../../ajudication/file/update/' + id;
      }
      this.goTo(link);
    },
    checkPermission (status) {
      if (this.roles.includes('ROLE_SUPERADMIN') || status == 'DRAFT') {
        return true;
      } else {
        return false;
      }
    },
    handlePageChange () {
      this.getSdsnList();
    },
    capitalize ([first, ...rest]) {
      return first.toUpperCase() + rest.join('');

    },
    dateFormatter (stringDate) {
      moment.locale("id");
      return moment(stringDate).format('LL');
    },
    listFormatter (value) {
      if (value) {
        let formattedList = '<div class="text-left">';
        value.split(';').forEach((item, index) => {
          formattedList = formattedList + '<div class="d-flex"><div>' + (index + 1) + '.&nbsp;</div><div>' + item + '</div></div>';
        });
        return formattedList + '</div>';
      } else {
        return '-';
      }
    }
  }
}
</script>
